
import { elem, styleInstaller } from "./chrome";

export const EXPAND_TASKBAR_WIDTH = 37;
export const EXPAND_TASKBAR_HEIGHT = 37;
/** `expandedtaskbar.py:9` is `SCREEN_WIDTH/2 - 5`. */
export const EXPAND_TASKBAR_X_OFFSET = 5;
/** TaskBar sits at `SCREEN_HEIGHT - 37`; this window sits one bar above it. */
export const EXPAND_TASKBAR_ABOVE_TASKBAR = 37;

const STYLE_ID = "expand-taskbar-style";

const STYLE = `
.expand-taskbar {
  position: fixed;
  left: calc(50% - ${EXPAND_TASKBAR_X_OFFSET}px);
  bottom: ${EXPAND_TASKBAR_ABOVE_TASKBAR}px;
  z-index: 80;
  width: ${EXPAND_TASKBAR_WIDTH}px;
  height: ${EXPAND_TASKBAR_HEIGHT}px;
  box-sizing: border-box;
  pointer-events: auto;
}
.expand-taskbar[hidden] { display: none; }
.expand-taskbar-dragonsoul {
  position: absolute;
  inset: 0;
  width: ${EXPAND_TASKBAR_WIDTH}px;
  height: ${EXPAND_TASKBAR_HEIGHT}px;
  padding: 0;
  border: 0;
  background: url("/ui/game/dragonsoul_button_01.png") center / 32px 32px no-repeat;
  image-rendering: pixelated;
  cursor: pointer;
  color: transparent;
  font: 0/0 sans-serif;
}
.expand-taskbar-dragonsoul:hover {
  background-image: url("/ui/game/dragonsoul_button_02.png");
}
.expand-taskbar-dragonsoul:active {
  background-image: url("/ui/game/dragonsoul_button_03.png");
}
`;

const installStyle = styleInstaller(STYLE_ID, STYLE);

export interface ExpandTaskBarActions {
  onDragonSoul?: () => void;
}

export class ExpandTaskBar {
  private readonly root: HTMLElement;
  private readonly dragonSoulButton: HTMLButtonElement;

  constructor(container: HTMLElement, actions: ExpandTaskBarActions = {}) {
    const doc = container.ownerDocument ?? document;
    installStyle(doc);

    this.root = elem(doc, "div", "expand-taskbar");
    this.root.hidden = true;
    this.root.setAttribute("role", "toolbar");
    this.root.setAttribute("aria-label", "Expanded task bar");

    this.dragonSoulButton = doc.createElement("button");
    this.dragonSoulButton.type = "button";
    this.dragonSoulButton.className = "expand-taskbar-dragonsoul";
    this.dragonSoulButton.textContent = "Dragon Soul";
    this.dragonSoulButton.title = "Deactivated";
    this.dragonSoulButton.setAttribute("aria-label", "Deactivated");
    this.dragonSoulButton.addEventListener("click", () => actions.onDragonSoul?.());
    this.root.append(this.dragonSoulButton);
    container.append(this.root);
  }

  get element(): HTMLElement {
    return this.root;
  }

  get hidden(): boolean {
    return this.root.hidden;
  }

  set hidden(value: boolean) {
    this.root.hidden = value;
  }

  toggle(): void {
    this.root.hidden = !this.root.hidden;
  }

  /** `DragonSoulGiveQuilification` (`interfacemodule.py`). Never reversed. */
  setDragonSoulQualified(qualified: boolean): void {
    const label = qualified ? "Dragon Stone Alchemy" : "Deactivated";
    this.dragonSoulButton.title = label;
    this.dragonSoulButton.setAttribute("aria-label", label);
  }
}
